import React, { FC } from 'react';
import styled from 'styled-components';

interface Props {
  theme?: string;
  position?: string;
  total: number;
  current: number;
  progress: number;
}

const Wrapper = styled.div<{ theme?: string; $position?: string }>`
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;

  ${({ $position }) =>
    $position === 'left' || $position === 'right'
      ? `
    flex-direction: column;
    width: 2px;
    height: 100%;
  ` : `
    flex-direction: row;
    width: 100%;
    height: 2px;
  `}

  .dot {
    flex: 1;
    background: ${({ theme }) =>
      theme === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)'};
    position: relative;
    height: 100%;
    width: 100%;
  }

  .fill {
    position: absolute;
    top: 0;
    left: 0;
    background: ${({ theme }) => (theme === 'dark' ? '#fff' : '#191A1F')};
    ${({ $position }) =>
      $position === 'left' || $position === 'right'
        ? 'width: 100%; height: 0%;'
        : 'width: 0%; height: 100%;'}
    transition: width 0.1s linear, height 0.1s linear;
  }
`;

const Pagination: FC<Props> = ({
  theme,
  position,
  total,
  current,
  progress,
}) => {
  const isVertical = position === 'left' || position === 'right';
  const dim = isVertical ? 'height' : 'width';

  return (
    <Wrapper theme={theme} $position={position}>
      {Array.from({ length: total }).map((_, i) => (
        <div key={i} className="dot">
          {current === i + 1 && (
          <div
            className="fill"
            style={{ [dim]: `${progress * 100}%` }}
          />
          )}
        </div>
      ))}
    </Wrapper>
  );
};

export default Pagination;